export const routerUrls = {
  root: '/',
  // Основной вход — токеном Яндекс Трекера: с ним работают и старый, и новый учёт
  login: '/login',
  // Вход через KTSID: хватает только новому учёту
  loginKtsid: '/login/ktsid',
  timesheets: '/timesheets',
  calendar: '/calendar',
  stopwatches: '/stopwatches',
  inDev: '/in-dev',
  settings: '/settings',
  // Собственный учёт времени (API v2); без префикса — legacy на Яндекс Трекере
  v2: {
    table: '/v2/table',
    calendar: '/v2/calendar',
  },
};
